import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.1_@azure+identity@4.7.0_@parcel+watcher@2.5.1_@types+node@24.0.0_db0@0.3.1_eslint@9_lkihim2quytil5hawyhmuxdspa/node_modules/nuxt/dist/pages/runtime/validate.js";
import custom_45domain_45redirect_45global from "/vercel/path0/apps/webapp/middleware/custom-domain-redirect.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.1_@azure+identity@4.7.0_@parcel+watcher@2.5.1_@types+node@24.0.0_db0@0.3.1_eslint@9_lkihim2quytil5hawyhmuxdspa/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  custom_45domain_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}